import {Component} from "@angular/core";
import { User } from "../../model/user.model";
import { NgForm } from "@angular/forms";
import { UserRepository } from "../../model/user.repository";
import { ActivatedRoute } from "@angular/router";

import { PATH_USER_CODE_URL } from "../../service/constants";
import { PATH_SUBSCRIPTION_CODE_URL } from "../../service/constants";
import { PATH_PASSWORD_RESET_CODE_URL } from "../../service/constants";
import { Subscription } from "../../model/subscription.model";
import { ValueStoreService } from 'src/app/service/value-store.service';
import { UserSubject } from '../../model/userSubject.model';
import { Behaviour } from '../../model/Behaviour.model';
import { Router } from '@angular/router';



@Component({
  templateUrl: "emailConfirmation.component.html",
  styleUrls: ["emailConfirmation.component.css"]
})
export class EmailConfirmationComponent {

  user: User = new User();
  sub: Subscription = new Subscription();

  public errorMessage: string;
  public successMessage: string;
  public hasXp: boolean = false;

  public lastUrlPath: string;
  public pathUserCodeUrl: string;
  public pathSubCodeUrl: string;
  public passRestCodeUrl: string;

  constructor(private userRepository: UserRepository, private route: ActivatedRoute,
    private valueStoreService: ValueStoreService, private router: Router) {
    this.lastUrlPath = this.route.snapshot.url[this.route.snapshot.url.length -1 ].path;
    this.pathUserCodeUrl = PATH_USER_CODE_URL;
    this.pathSubCodeUrl = PATH_SUBSCRIPTION_CODE_URL;
    this.passRestCodeUrl = PATH_PASSWORD_RESET_CODE_URL;
  }

  postComment(form: NgForm) {
    if (form.valid) {
      if (this.lastUrlPath.toLowerCase() === this.pathUserCodeUrl.toLowerCase()) {
        this.confirmUserEmailCode(form);
      } else if (this.lastUrlPath.toLocaleLowerCase() === this.pathSubCodeUrl.toLocaleLowerCase()) {
        this.confirmSubEmailCode(form);
      }
    } else {
      this.errorMessage = "Form Data Invalid";
    }

  }

  confirmUserEmailCode(form: NgForm): void {
    this.userRepository.confirmUserEmailCode(this.user).subscribe(response => {
       // console.log(response.message);
       /**
           * Check if User has XP points
        */
       let userSubjects:UserSubject[] = this.valueStoreService.getUserSubjectsWithXPFromSession();
       if (userSubjects !=null && userSubjects.length > 0) {
        this.hasXp = true;
       }

      this.successMessage = response.message;
      this.errorMessage = null;
      form.reset();
    }, error=> {
      this.errorMessage = error;
      this.successMessage = null;
    })
  }


   navigateToMyAccount(position: string) {

    let behaviour: Behaviour = new Behaviour();
    behaviour.description = "User is clicking my-account button from "+position+" landing/store comp page";
    this.userRepository.trackUserBehaviour(behaviour);

    this.router.navigate(['myaccount']);
  }

  confirmSubEmailCode(form: NgForm): void {
    this.userRepository.confirmSubEmailCode(this.sub).subscribe(response => {
      this.successMessage = response.message;
      this.errorMessage = null;
      form.reset();
    }, error=> {
      this.errorMessage = error;
      this.successMessage = null;
    })
  }

  getWindowInnerHeight():number {
    return window.innerHeight;
  }

  getMainContainerHeight():number {
    return document.querySelector('#main-container').clientHeight;
  }

  getOptimalMainContainerHeight():string {
    if (this.getMainContainerHeight() >= this.getWindowInnerHeight()) {
      let pixel = this.getMainContainerHeight();
     console.log(`height to set to main container as it is bigger than window height ${pixel}, ${this.getWindowInnerHeight()}`);
      return pixel+"px";
    } else {
      //footer is 200px and nav is around 50px
      let pixel = (this.getWindowInnerHeight() - (200+this.getMainContainerHeight())) +this.getMainContainerHeight();
     console.log(`height to set to main container as it is smaller than window height ${pixel} , ${this.getWindowInnerHeight()}`);

      return this.getWindowInnerHeight()+200+"px";
    }
  }






}
